import { createFileRoute } from "@tanstack/react-router";

import { CONTENT_CACHE_CONTROL } from "@/content/cachePolicy";
import HomePage from "./home/-components/HomePage";
import { homeCms } from "./home/-components/homeSource";
import { topLocationsCms } from "@/content/locationSource";

/**
 * The marketing home page.
 *
 * `/home` and not `/`: the team has not settled whether this replaces the
 * published root, so it ships beside it. Moving it is this string, the same
 * string in `src/content/prerenderPages.ts` and `PRERENDERED_SURFACES`, and the
 * canonical in `homeContent.ts`, which points at the live root until then.
 *
 * A sibling of `_app` for the reason `blog` and `academy` are: the page is
 * public and `_app`'s guard would bounce an anonymous reader to sign-in.
 */
export const Route = createFileRoute("/home")({
  loader: async () => {
    const [cms, locations] = await Promise.all([homeCms(), topLocationsCms()]);
    return { ...cms, locations };
  },
  headers: () => ({ "Cache-Control": CONTENT_CACHE_CONTROL }),
  component: HomeRoute,
});

function HomeRoute() {
  const { heroVideo, locations } = Route.useLoaderData();
  return <HomePage heroVideo={heroVideo} locations={locations} />;
}
